import { render, staticRenderFns } from "./loading-text.vue?vue&type=template&id=5c1b2f19&functional=true"
import script from "./loading-text.vue?vue&type=script&lang=ts"
export * from "./loading-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports